/**
 * Default navigation configuration — the start assignment from the design
 * handoff ("Default-Konfiguration — bitte übernehmen"). This is what new users
 * (and a fresh localStorage) get, and what `resetConfig` restores to.
 *
 * Group ids are stable (t1/t2, a1..a5, b1..b3) so a stored config can be migrated.
 */
import { NavConfig, NavGroup, NavPage, PageId } from './navTypes';

const pg = (id: PageId, hidden = false): NavPage => ({ id, hidden });
const grp = (id: string, name: string, ids: PageId[]): NavGroup => ({
  id,
  name,
  pages: ids.map((i) => pg(i)),
});

export const DEFAULT_NAV_CONFIG: NavConfig = {
  tutor: {
    groups: [
      grp('t1', 'Schulung', ['dashboard', 'runs', 'runscalendar', 'participants', 'rooms']),
      grp('t2', 'Vorbereitung', ['workloads', 'apps', 'images', 'newimage', 'finops']),
      grp('t3', 'Hilfe', ['hilfe', 'changelog', 'wiki']),
    ],
    tray: [pg('installers'), pg('settings')],
  },
  admin: {
    groups: [
      grp('a1', 'Übersicht', ['dashboard']),
      grp('a2', 'Schulungsbetrieb', ['runs', 'runscalendar', 'participants', 'rooms']),
      grp('a3', 'Images & Workloads', ['workloads', 'apps', 'appsregister', 'installers', 'images', 'newimage', 'buildlogs']),
      grp('a4', 'Verwaltung', ['users', 'costcenters', 'finops', 'audit', 'events', 'seitenzuordnung']),
      grp('a5', 'Hilfe', ['hilfe', 'changelog', 'wiki', 'settings']),
    ],
    tray: [],
  },
  betrieb: {
    groups: [
      grp('b1', 'Monitoring', ['dashboard', 'status', 'logs', 'finops']),
      grp('b2', 'Infrastruktur', ['azure', 'drift', 'images', 'buildlogs']),
      grp('b3', 'Prüfung', ['audit']),
    ],
    tray: [pg('settings')],
  },
};
